export default async function LoadGoogleMap(mapKey: string): Promise<void> {
  const base = new URL("https://maps.googleapis.com/");
  const url = new URL("maps/api/js", base);
  url.searchParams.append("v", "3");
  url.searchParams.append("libraries", "geometry,drawing,places");
  url.searchParams.append("key", mapKey);

  const scriptId = "google-map-autoloader";
  const repeatScript = document.head.querySelector(`#${scriptId}`);
  if (repeatScript) {
    if (google?.maps?.Map) {
      return;
    }

    repeatScript.remove();
  }

  await new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "text/javascript";
    script.src = url.toString();
    document.head.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
  });
}
